let Store = null;

export function saveStore(createdStore) {
    Store = createdStore;
}
export function getStore() {
    return Store;
}

export function getState() {
    return getStore()?.getState();
}

window.getState = getState;